'use strict';

angular.module('atex.dam').factory('DamSchedulingService', [ '$q', '$translate', '$http', 'AssignService', 'UserProfileService', 'configuration','DamTemplateService', 'AuthenticationService', 'DamNotificationService','DamConfigurationService','DamActivityService','DamService', 'SearchService', 'ContentService',
  function ($q, $translate, $http, AssignService, UserProfileService, configuration, DamTemplateService, AuthenticationService,DamNotificationService,DamConfigurationService, DamActivityService, DamService, SearchService, ContentService) {

    var defaultSecurityParent = "dam.assets.common.d";

    function DamSchedulingService() {}

    DamSchedulingService.createSchedule = function (data) {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
          var transferInfo = {
            data: data
          };
          transferInfo.data.aspects['p.InsertionInfo'] = {
            data: {
              _type: 'p.InsertionInfo',
              securityParentId: 'externalid/' + defaultSecurityParent
            }
          };
          transferInfo.data.aspects['atex.dam.standard.ContentAccess'] = {
            data: {
              _type: 'atex.dam.standard.ContentAccess',
              "assignees": [
                {
                  "externalId": currentUserInfo.externalId,
                  "owner": true
                }
              ],
              "creator": currentUserInfo.externalId
            }
          };
        return ContentService.createContent(transferInfo).then(function (response) {
          return ContentService.getContent({id: response.id});
        });
      });
    };

    DamSchedulingService.generateId = function () {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    };

    DamSchedulingService.createContent = function (data) {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        var transferInfo = {
          data: data
        };

        return ContentService.createContent(transferInfo).then(function (response) {
          return ContentService.getContent({id: response.id});
        });
      });
    };

    DamSchedulingService.updateContent = function(transferInfo) {
      return ContentService.updateContent(transferInfo);
    };

    DamSchedulingService.updateAssigneesForScheduleInstances = function(content, contentAccess) {
      return ContentService.getContent({id: content.id}).then(function (instance) {
         atex.onecms.ObjectUtils.accessor(instance, "data/aspects/atex.dam.standard.ContentAccess").value = contentAccess;
         delete instance.data.aspects['atex.dam.standard.ContentAccess'].data.assignees_element_types;
         var updateInfo = { id: content.id, data: instance.data, revision: instance.revision};

         return ContentService.updateContent(updateInfo).then(function (response) {
            return response;
         });
      });
    };

    DamSchedulingService.getInstancesForSchedule = function (scheduleId) {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        return DamService.getSolrServerInfo().then(function (solrInfo) {
          var query =  '+type:(atex.dam.standard.PublishingSchedule)';
          query += '+schedule_instance_b:(true)';
          query += '+parent_schedule_id_atex_desk_s:(\"' + scheduleId +'\")';
          var sort = 'publication_atex_desk_ss asc';
          var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort);

          return SearchService.search(transferInfo).then (function (response) {
            var result = [];
            if (response && response.data.response.docs) {
              response.data.response.docs.forEach(function (doc) {
                var scheduleInstance = doc._data;
                if (scheduleInstance !== undefined) {
                  result.push(scheduleInstance);
                }
              });
            }
            return result;
          });
        });
      });
    };

    DamSchedulingService.updateSchedule = function(transferInfo) {
      return ContentService.updateContent(transferInfo);
    };

    DamSchedulingService.deletePublishingSchedule = function (id) {
      return this.getSchedulingContent(id).then(function (schedule) {

        var retrieveContent = function retrieveContent(id) {
          return DamSchedulingService.deleteDefault(id.defaultTemplateContentId)
            .catch(function (error) {
              if (!error || error.type !== atex.onecms.error.types.NOT_FOUND) {
                throw error;
              }
            });
        };

        if (schedule !== undefined) {
          var items = schedule.data.aspects.contentData.data.items;

          var itemsWithDefaults = items.filter(function (item) {
            return item.defaultTemplateContentId !== undefined;
          });

          if (itemsWithDefaults && itemsWithDefaults.length > 0) {
            var actions = items.map(retrieveContent);

            return $q.all(actions).then(function (_) {
                return ContentService.deleteContent({id: schedule.id, revision: schedule.revision}).then(function () {
                  return schedule;
                });
            });
          } else {
            return ContentService.deleteContent({id: schedule.id, revision: schedule.revision}).then(function () {
              return schedule;
            });
          }
        }
      });
    };

    DamSchedulingService.deleteDefault = function (id) {
      return DamSchedulingService.getInstanceByIdForDeletion(id).then(function (content) {
        return ContentService.deleteContent({id: content.id, revision: content.revision}).then(function () {
          return content;
        });
      });
    };

    DamSchedulingService.deletePublishingScheduleInstance = function (id) {
      return this.getSchedulingContent(id).then(function (schedule) {

        if (schedule !== undefined) {
          return DamSchedulingService.getContentForInstance(schedule).then(function (contentList) {
            if (contentList) {

              var ids = atex.dam.AngularUtils.getIdsArray(contentList);
              var locked = false;
              return DamActivityService.lock(ids).then(function (responses) {
                locked = true;
                var retrieveContent = function retrieveContent(content) {
                  return DamSchedulingService.getInstanceByIdForDeletion(content.id).then(function (response) {
                    var isTrashVisible = configuration.getTrashId() !== undefined;
                    return DamService.deleteContent(response.id, isTrashVisible).then(null, function (error) {
                      return undefined;
                    });
                  });
                };

                var actions = contentList.map(retrieveContent);

                return $q.all(actions).then(function (response) {
                  return ContentService.deleteContent({id: schedule.id, revision: schedule.revision}).then(function () {
                    return schedule;
                  });
                });

              }).then(function (response) {
                return DamActivityService.unlock(ids).then(function() {
                  return response;
                });
              }).then(null, function (error) {
                if (locked) {
                 return DamActivityService.unlock(ids).then(function () {
                   return $q.reject(error);
                 });
                }
                return $q.reject(error);
              });
            } else {
              return ContentService.deleteContent({id: schedule.id, revision: schedule.revision}).then(function () {
                return schedule;
              });
            }
          });
        }
      });
    };

    DamSchedulingService.getInstanceByIdForDeletion = function(id) {
      return ContentService.getContent({id: id});
    };

    DamSchedulingService.getSchedulingContent = function(id)  {
      return ContentService.getContent({id: id});
    };
    
    DamSchedulingService.loadInstancesById = function (id) {
      return DamSchedulingService.getSchedulingContent(id).then(function (result) {
        DamSchedulingService.setOwnerDetails(result.data);
        return result;
      });
    };

    DamSchedulingService.setOwnerDetails = function (schedule) {
      DamService.getCurrentDamUserInfo().then(function (userInfo) {
        var access = schedule.aspects['atex.dam.standard.ContentAccess'];
        var assignees = access ? access.data.assignees : undefined;
        var owners = AssignService.getOwnersFromAssignees(assignees);
        schedule.isOwner = userInfo.isAdm || AssignService.isUserOwner(userInfo.externalId, userInfo.groups, owners);
        schedule.isInherited = access.data.creator !== userInfo.externalId;
        schedule.isShared = assignees !== undefined && assignees.length > 1;
      });
    };

    DamSchedulingService.setOwnerDetailsLocal = function (schedule, userInfo) {
        var access = schedule.aspects['atex.dam.standard.ContentAccess'];
        var assignees = access ? access.data.assignees : undefined;
        var owners = AssignService.getOwnersFromAssignees(assignees);
        schedule.isOwner = userInfo.isAdm || AssignService.isUserOwner(userInfo.externalId, userInfo.groups, owners);
        schedule.isInherited = access.data.creator !== userInfo.externalId;
        schedule.isShared = assignees !== undefined && assignees.length > 1;
    };

    DamSchedulingService.getAllSchedules = function()  {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        return DamService.getSolrServerInfo().then(function (solrInfo) {
          var query =  '+type:(atex.dam.standard.PublishingSchedule)';
          query += '+schedule_instance_b:(false)';
          var sort = 'publication_atex_desk_ss asc';
          var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort, currentUserInfo);
          return SearchService.search(transferInfo).then (function (response) {
            var result = [];
            if (response && response.data.response.docs) {
              response.data.response.docs.forEach(function (doc) {
                var schedule = doc._data;
                if (schedule !== undefined) {
                  DamSchedulingService.setOwnerDetailsLocal(schedule, currentUserInfo);
                  result.push(schedule);
                }
              });
            }
            return result;
          });
        });
      });
    };
    
    DamSchedulingService.getUniquePublicationSchedules = function()  {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        return DamService.getSolrServerInfo().then(function (solrInfo) {

          var query =  '+type:(atex.dam.standard.PublishingSchedule)';
          var sort = 'publication_atex_desk_ss asc';
          var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort, currentUserInfo);
          transferInfo['facet.mincount'] =  "1";
          transferInfo['facet.limit'] =  "1000";
          transferInfo['facet']="true";
          transferInfo['rows'] = '0';
          transferInfo['start'] = '0';
          transferInfo['facet.field'] = "publication_atex_desk_ss";
          return SearchService.search(transferInfo).then (function (response) {
            var result = [];
            if (response && response.data.facet_counts.facet_fields) {
              response.data.facet_counts.facet_fields['publication_atex_desk_ss'].forEach(function (facet) {
                var publication = facet;
                if (publication !== undefined && isNaN(publication)) {
                  result.push(publication);
                }
              });
            }
            return result;
          });
        });
      });
    };

    DamSchedulingService.getInstancesByDateAndPublication = function(publications, dates) {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        return DamService.getSolrServerInfo().then(function (solrInfo) {

          var query =  '+type:(atex.dam.standard.PublishingSchedule)';
          query += '+schedule_instance_b:(true)';
          if (dates && dates.length > 1 && dates[0] && dates[1]) {
             query += "+pubdate_atex_desk_dt:[" + dates[0] + " TO " + dates[1] + "]";
          } else if (dates && dates.length > 0 && dates[0]) {
            query += "+pubdate_atex_desk_dt:[" + dates[0] + "]";
          }

          if (publications && publications.length > 0) {

            publications.forEach(function (pub, index) {
              if (index === 0) {
                query += '+publication_atex_desk_ss:("'+ pub;
              } else {
                query += '" OR "' + pub;
              }
            });
            query += '")';
          }

          var sort = 'pubdate_atex_desk_dt desc';
          var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort, currentUserInfo);
          return SearchService.search(transferInfo).then (function (response) {
            var result = [];
            if (response && response.data.response.docs) {
              response.data.response.docs.forEach(function (doc) {
                var scheduleInstance = doc._data;
                if (scheduleInstance !== undefined) {
                  DamSchedulingService.setOwnerDetailsLocal(scheduleInstance, currentUserInfo);
                  result.push(scheduleInstance);
                }
              });
            }
            return result;
          });
        });
      });
    };
    
    DamSchedulingService.getInstancesForPublication = function(publication,fromDate,toDate)  {
      return DamService.getSolrServerInfo().then(function (solrInfo) {
        var query =  '+type:(atex.dam.standard.PublishingSchedule)';
        query += '+schedule_instance_b:(true)';
        query += '+publication_atex_desk_ss:("'+ publication + '")';
        query += "+pubdate_atex_desk_dt:[" + fromDate + " TO " + toDate + "]";
        var sort = 'publication_atex_desk_ss asc';
        var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort);

        return SearchService.search(transferInfo).then (function (response) {
          var result = [];
          if (response && response.data.response.docs) {
            response.data.response.docs.forEach(function (doc) {
              var scheduleInstance = doc._data;
              if (scheduleInstance !== undefined) {
                DamSchedulingService.setOwnerDetails(scheduleInstance);
                result.push(scheduleInstance);
              }
            });
          }
          return result;
        });
      });
    };

    DamSchedulingService.getPublishingScheduleAssociatedToPublication = function(publication)  {
      if (publication) {
        return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
          return DamService.getSolrServerInfo().then(function (solrInfo) {
            var query =  '+type:(atex.dam.standard.PublishingSchedule)';
            query += '+schedule_instance_b:(false)';
            query += '+publication_atex_desk_ss:("'+ publication + '")';
            var sort = 'publication_atex_desk_ss asc';
            var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort, currentUserInfo);
            transferInfo['rows'] = '1';
            return SearchService.search(transferInfo).then (function (response) {
              if (response && response.data.response.docs && response.data.response.docs.length > 0) {
                var schedule = response.data.response.docs[0]._data;
                DamSchedulingService.setOwnerDetailsLocal(schedule, currentUserInfo);
                return schedule;
              }
            });
          });
        });
      }
        return undefined;
    };

    function generateTransferInfo (query, solrCore, sort, currentUserInfo) {
      var transferInfo = {
        core : solrCore,
        variant : 'list',
        q : query,
        fl : 'id',
        sort : sort,
      };

      if (currentUserInfo && !currentUserInfo.isAdm) {
        transferInfo['q'] += '+assignees_atex_desk_sms:(';
        transferInfo['q'] += currentUserInfo.externalId;

        for (var i = 0; currentUserInfo.groups && i < currentUserInfo.groups.length; i++) {
          var escaped = currentUserInfo.groups[i].principalId.replace(':', '\\:');
          transferInfo['q'] += ' OR ' + escaped;
      }

        transferInfo['q'] += ')';
      }
      return transferInfo;
    }

    DamSchedulingService.getPublishingSchedulesForPublication = function(publication)  {
      return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
        return DamService.getSolrServerInfo().then(function (solrInfo) {

          var query =  '+type:(atex.dam.standard.PublishingSchedule)';
          query += '+schedule_instance_b:(false)';

          if (publication) {
            query += '+publication_atex_desk_ss:("'+ publication + '")';
          }

          var sort = 'publication_atex_desk_ss asc';
          var transferInfo = generateTransferInfo(query, solrInfo.solrCore, sort, currentUserInfo);

          return SearchService.search(transferInfo).then (function (response) {
            var result = [];
            if (response && response.data.response.docs) {
              response.data.response.docs.forEach(function (doc) {
                var scheduleInstance = doc._data;
                if (scheduleInstance !== undefined) {
                  DamSchedulingService.setOwnerDetailsLocal(scheduleInstance, currentUserInfo);
                    result.push(scheduleInstance);
                }
              });
            }
            return result;
          });
        });
      });
    };

    DamSchedulingService.getContentForInstance = function(instance)  {
      return DamService.getSolrServerInfo().then(function (solrInfo) {
        var transferInfo = {};
        transferInfo['core'] = solrInfo.solrCore;
        transferInfo['variant'] = 'list';
        transferInfo['fl'] = 'id';
        transferInfo['q'] = "+schedule_instance_id_atex_desk_s:(\"" + instance.id + "\")";

        return SearchService.search(transferInfo).then (function (response) {
          var result = [];
          if (response && response.data.response.docs) {
            response.data.response.docs.forEach(function (doc) {
              var content = doc._data;
              if (content !== undefined) {
                result.push(content);
              }
            });
          }
          return result;
        });
      });
    };

    DamSchedulingService.addContentToScheduleInstance = function(ids, node, copy) {
      var deferred = $q.defer();
      var locked = false;

      DamActivityService.lock(ids).then(function(responses) {
        locked = true;
        return ContentService.getContent({id: node.value.id});
      }).then(function(content) {
        return $q.when(content);
      }).then(function(content) {
        var getPromises = ids.map(function(id) {
          return ContentService.getContent({id:id}).then(function(response) {
            return response;
          });
        });
        return $q.all(getPromises);
      }).then(function(contents) {
        var savePromises = [];
        contents.map(function(result) {
          if (result) {
            var scheduleInstanceId = atex.onecms.ObjectUtils.getByPath(result, "data/aspects/atex.dam.standard.Scheduling/data/scheduleInstanceId");
            if (scheduleInstanceId) {
              result.data.aspects["atex.dam.standard.Scheduling"].data.scheduleInstanceId = node.value.id;
            } else {
              result.data.aspects["atex.dam.standard.Scheduling"] = {
                data: {
                  _type: 'atex.dam.standard.Scheduling',
                  scheduleInstanceId: node.value.id
                }
              };
            }
            var updateInfo = { id: result.id, data: result.data, revision: result.revision};
            savePromises.push(ContentService.updateContent(updateInfo).then(function(response) {
                  return response;
                })
            );
          }
        });
        return $q.all(savePromises);
      }).then(function(contents) {
        var message;
        if (contents.length) {
          message = $translate.getTranslationTable().__PUBLISHING_SCHEDULE_CONTENT_ADDED__;
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: message }), false);
        }
        deferred.resolve(contents);
        DamActivityService.unlock(ids);
      }).then(null, function(error) {
        if (locked) {
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
          DamActivityService.unlock(ids);
        }
        deferred.reject(error);
      });
      return deferred.promise;
    };
    return (DamSchedulingService);
  }]);
